import React, { useState, useEffect } from "react";
import { saveNotes } from "../../services/newdaily";
import { Textarea } from "@fluentui/react-components";
import LockerIcon from "../../assets/svgs/locker.svg";
import ArrowIcon from "../../assets/svgs/arrow-down.svg";
import ArrowUpIcon from "../../assets/svgs/arrow-up.svg";
import styles from "./Notes.module.css";

const Notes = ({ initialNotes = "", userId }) => {
  const [notes, setNotes] = useState(initialNotes);
  const [originalNotes, setOriginalNotes] = useState(initialNotes);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    setNotes(initialNotes || "");
    setOriginalNotes(initialNotes || "");
  }, [initialNotes]);

  const handleBlur = async () => {
    if (notes !== originalNotes && userId) {
      try {
        await saveNotes({ userId, notas: notes });
        setOriginalNotes(notes);
      } catch (error) {
        console.error("❌ Error guardando notas:", error);
      }
    }
  };

  return (
    <div className={styles.notesContainer}>
      <div
        className={styles.notesHeader}
        onClick={() => setIsExpanded((v) => !v)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") setIsExpanded((v) => !v);
        }}
      >
        <div className={styles.notesHeaderLeft}>
          <img src={LockerIcon} alt="Locker" className={styles.lockerIcon} />
          <h3 className={styles.notesTitle}>Notas personales</h3>
        </div>

        <img
          src={isExpanded ? ArrowUpIcon : ArrowIcon}
          alt="Toggle"
          className={styles.arrowIcon}
        />
      </div>


      {isExpanded && (
        <Textarea
          className={styles.notesTextarea}
          placeholder="Un espacio permanente para tus ideas y recordatorios. Este contenido es solo visible para ti."
          resize="none"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          onBlur={handleBlur}
        />
      )}
    </div>
  );
};

export default Notes;
